module.exports = __webpack_public_path__ + "assets/img/IMG608.e6fa5f9b.jpg";